import EdCourseTemplateComponent from './ed-course-template/ed-course-template.component.vue';
import EdCourseTemplateSectionComponent from './ed-course-template-section/ed-course-template-section.component.vue';
import EdSubjectComponentItem from './ed-subject-component-item/ed-subject-component-item.component';

export const CourseTemplateComponents = {
  EdCourseTemplateComponent,
  EdCourseTemplateSectionComponent,
  EdSubjectComponentItem,
}